import { render } from "./AudioSelectorInput.vue?vue&type=template&id=44b44ef6&scoped=true"
import script from "./AudioSelectorInput.vue?vue&type=script&lang=js"
export * from "./AudioSelectorInput.vue?vue&type=script&lang=js"

import "./AudioSelectorInput.vue?vue&type=style&index=0&id=44b44ef6&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b44ef6"]])

export default __exports__